import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <section className="text-center mt-5">
      <h1 className="display-4">404</h1>
      <p className="lead">Page not found</p>
      <Link to="/dashboard" className="btn btn-primary">Go Home</Link>
    </section>
  );
};

export default NotFound;
